// actionTypes
export const UPDATE_TITLE = "UPDATE_TITLE";

export const UPDATE_DESC_POINTS = "UPDATE_DESC_POINTS";


// action creators
export const updateTitle = (title) => ({
  type: UPDATE_TITLE,
  payload: title,
});


export const updateDescPoints = (descPoints) => ({
  type: UPDATE_DESC_POINTS,
  payload: descPoints,
});

